/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Build_Your_Own_Ai_Whole_Day22Inputs */

const en__field_enum_build_your_own_ai_whole_day22 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Whole_Day22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`full day`)
};

const de__field_enum_build_your_own_ai_whole_day22 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Whole_Day22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ganztägig`)
};

/**
* | output |
* | --- |
* | "full day" |
*
* @param {_Field_Enum_Build_Your_Own_Ai_Whole_Day22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_build_your_own_ai_whole_day22 = /** @type {((inputs?: _Field_Enum_Build_Your_Own_Ai_Whole_Day22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Build_Your_Own_Ai_Whole_Day22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_build_your_own_ai_whole_day22(inputs)
	return de__field_enum_build_your_own_ai_whole_day22(inputs)
});
export { _field_enum_build_your_own_ai_whole_day22 as "_field_enum_BUILD_YOUR_OWN_AI_WHOLE_DAY" }